import type { ReactElement } from 'react';
import { gasMeUpTalkLine } from '../../../../../shared/gas-me-up-handoff.js';
import { GamesTalkHandoff } from './GamesTalkHandoff';

/**
 * Where Ember games' Gas Me Up hands a person to Ember (2026-10-30 Riley):
 * the portal beside the game's Ember. The link carries only the door and, from
 * a card, its type — never a word anyone typed; the first line is written from
 * those (shared/gas-me-up-handoff.js), and the page is the games' shared one.
 */
export function GasMeUpTalkHandoff({ search }: { search: URLSearchParams }): ReactElement {
  return (
    <GamesTalkHandoff
      line={gasMeUpTalkLine(search.get('gasmeup'), search.get('type'))}
      discovery="gas_me_up"
    />
  );
}
